/**
 * Auto-trim decimal parts from integer inputs
 *
 * Browsers allow entering values like "5.0" in number inputs even with step="1".
 * This causes Ecto casting errors since "5.0" is not a valid integer string.
 *
 * This utility automatically trims the decimal part when:
 * - The input has type="number"
 * - The step is an integer (no decimal point) or not specified (defaults to 1)
 * - The value has a decimal part that is effectively zero (e.g., 5.0, 10.00)
 *
 * Triggers on form submit (Enter key or button click).
 */

document.addEventListener("submit", function (event) {
  const form = event.target;
  for (const input of form.elements) {
    if (input.type !== "number") continue;
    const step = input.getAttribute("step") || "1";
    if (!Number.isNaN(input.valueAsNumber) && !step.includes(".")) {
      // Enzo's weird trick: If the input shows 1.0, valueAsNumber is actually 1
      input.value = input.valueAsNumber;
    }
  }
});
